/*
  NHS landing page "Flat Out 2.0" — behaviour for sections/nhs-fo2-*.liquid.
  Source: scripts/_nhs-theme/theme-src/flat-out-2/ — deployed by scripts/_nhs-theme/deploy-fo2.mjs.

  Every fo2 section loads this file; the guard below makes it run once. All interaction goes through
  ONE delegated click listener, so sections re-rendered by the theme editor keep working; counts and
  the egg are re-initialised on `shopify:section:load`.

  Cart: POST theme.routes.cartAdd (/cart/add.js) with {items:[…]}, then the theme's own event
  `ajaxProduct:added` → Impulse CartDrawer rebuilds and opens (pattern: nhs-giftcard.js). The
  section must NOT carry data-section-type="product" (theme.js would boot theme.Product and crash).
*/
(function () {
  'use strict';
  if (window.__nhsFo2) return;
  window.__nhsFo2 = true;

  var DEAL_KEY = 'nhs-fo2-code-applied';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- money ---------- */
  function formatMoney(cents) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (err) {
      console.error('nhs-fo2: formatMoney failed', err);
    }
    return (cents / 100).toLocaleString('de-AT', { style: 'currency', currency: 'EUR' });
  }

  /* ---------- scrolling ---------- */
  function scrollToTarget(hash) {
    var el = hash && hash.charAt(0) === '#' ? document.getElementById(hash.slice(1)) : null;
    if (!el) return false;
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', hash);
    return true;
  }

  /* ---------- entry list filter ---------- */
  function applyFilter(section, id) {
    if (!section) return;
    $all('[data-fo2-filter]', section).forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-fo2-filter') === id ? 'true' : 'false');
    });
    $all('[data-fo2-item]', section).forEach(function (item) {
      var show = id === 'all' || item.getAttribute('data-cat') === id || item.getAttribute('data-livery') === id;
      item.hidden = !show;
      if (!show) closePanel(item);
    });
    // "Also in the drop" divider only while one of its pieces is visible
    var divider = section.querySelector('[data-fo2-divider]');
    if (divider) divider.hidden = !$all('[data-fo2-item][data-fo2-extra]', section).some(function (i) { return !i.hidden; });
  }

  /* livery buttons show "(n)" — n comes from the entry list's own filter counts */
  function fillLiveryCounts() {
    $all('[data-fo2-count]').forEach(function (span) {
      var id = span.getAttribute('data-fo2-count');
      var filter = document.querySelector('[data-fo2-filter="' + id + '"][data-fo2-livery-count]');
      if (filter) {
        span.textContent = '(' + filter.getAttribute('data-fo2-livery-count') + ')';
        span.hidden = false;
      } else {
        span.hidden = true;
      }
    });
  }

  /* ---------- quick-add panel ---------- */
  function closePanel(item) {
    var panel = item && item.querySelector('[data-fo2-panel]');
    var btn = item && item.querySelector('[data-fo2-quick]');
    if (panel) panel.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }
  function togglePanel(btn) {
    var item = btn.closest('[data-fo2-item]');
    var panel = item && item.querySelector('[data-fo2-panel]');
    if (!panel) return;
    var open = panel.hidden;
    $all('[data-fo2-item]').forEach(function (other) { if (other !== item) closePanel(other); });
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var first = panel.querySelector('[data-fo2-add]:not(:disabled)');
      if (first) first.focus({ preventScroll: true });
    }
  }

  /* ---------- cart ---------- */
  function message(scope, text, isError) {
    var el = scope && scope.querySelector('[data-fo2-msg]');
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('fo2-msg--error', !!isError);
    if (text && !isError) {
      clearTimeout(el._fo2Timer);
      el._fo2Timer = setTimeout(function () { el.textContent = ''; }, 4000);
    }
  }
  function sectionText(el, key, fallback) {
    var s = el && el.closest('[data-msg-added]');
    return (s && s.getAttribute(key)) || fallback;
  }
  function errorText(data, fallback) {
    if (data && typeof data.description === 'string' && data.description) return data.description;
    if (data && typeof data.message === 'string' && data.message) return data.message;
    return fallback;
  }

  function addToCart(items, btn, scope) {
    var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    var added = sectionText(btn, 'data-msg-added', 'Added to cart');
    var failed = sectionText(btn, 'data-msg-error', 'Could not add — please try again');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    message(scope, '');
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) {
          console.error('nhs-fo2: add to cart failed', r.data);
          message(scope, errorText(r.data, failed), true);
          return false;
        }
        message(scope, added, false);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: r.data && r.data.items ? r.data.items[0] : r.data, addToCartBtn: btn }
        }));
        return true;
      })
      .catch(function (err) {
        console.error('nhs-fo2: add to cart error', err);
        message(scope, failed, true);
        return false;
      })
      .then(function (ok) {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        return ok;
      });
  }

  /* ---------- reversible sides ---------- */
  function showSide(tab) {
    var card = tab.closest('[data-fo2-rev]');
    if (!card) return;
    var side = tab.getAttribute('data-fo2-side');
    $all('[data-fo2-side]', card).forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    $all('[data-fo2-side-pane]', card).forEach(function (pane) { pane.hidden = pane.getAttribute('data-fo2-side-pane') !== side; });
  }

  /* ---------- full set ---------- */
  function pickSetSize(btn) {
    var row = btn.closest('[data-fo2-set-row]');
    if (!row) return;
    $all('[data-fo2-set-size]', row).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    row.setAttribute('data-variant', btn.getAttribute('data-fo2-set-size'));
  }
  function addSet(btn) {
    var set = btn.closest('[data-fo2-set]');
    var rows = $all('[data-fo2-set-row]', set);
    var items = rows.map(function (r) { return r.getAttribute('data-variant'); }).filter(Boolean).map(function (id) {
      return { id: Number(id), quantity: 1 };
    });
    if (items.length !== rows.length || !items.length) {
      message(set, sectionText(btn, 'data-msg-error', 'Could not add — please try again'), true);
      return;
    }
    addToCart(items, btn, set);
  }

  /* ---------- easter egg ---------- */
  function egg() { return document.getElementById('fo2-egg'); }
  function initEgg() {
    var dlg = egg();
    $all('[data-fo2-egg-plain]').forEach(function (s) { s.hidden = !!dlg; });
    $all('.fo2-strip [data-fo2-egg-open]').forEach(function (b) { b.hidden = !dlg; });
    applyDeal();
  }
  function openEgg() {
    var dlg = egg();
    if (!dlg) return;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function closeEgg() {
    var dlg = egg();
    if (!dlg) return;
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }
  function applyDeal() {
    var dlg = egg();
    var code = dlg && dlg.getAttribute('data-code');
    var pct = dlg ? Number(dlg.getAttribute('data-percent')) : 0;
    var stored = null;
    try { stored = window.localStorage.getItem(DEAL_KEY); } catch (err) { console.error('nhs-fo2: localStorage read failed', err); }
    var on = !!(dlg && code && pct > 0 && stored === code);
    $all('.fo2').forEach(function (s) { s.classList.toggle('fo2-deal-on', on); });
    if (!on) return;
    $all('[data-fo2-price]').forEach(function (box) {
      var cents = Number(box.getAttribute('data-fo2-price'));
      var deal = box.querySelector('[data-fo2-deal]');
      if (deal && cents > 0) deal.textContent = formatMoney(Math.round(cents * (100 - pct) / 100));
    });
  }
  function copyCode(btn) {
    var dlg = egg();
    var code = dlg && dlg.getAttribute('data-code');
    if (!code) return;
    var done = function () { btn.textContent = btn.getAttribute('data-copied') || 'Copied'; };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function (err) { console.error('nhs-fo2: copy failed', err); });
    }
  }
  function applyCode() {
    var dlg = egg();
    var code = dlg && dlg.getAttribute('data-code');
    if (!code) return;
    try { window.localStorage.setItem(DEAL_KEY, code); } catch (err) { console.error('nhs-fo2: localStorage write failed', err); }
    // Shopify stores the code in the checkout via /discount/<code> and redirects back here.
    var back = window.location.pathname + window.location.search + '#fo2-entry-list';
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  }

  /* ---------- one delegated listener ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t) return;
    var el;

    if ((el = t.closest('[data-fo2-filter]'))) {
      applyFilter(el.closest('[data-fo2-section="entry-list"]'), el.getAttribute('data-fo2-filter'));
      return;
    }
    if ((el = t.closest('[data-fo2-filter-go]'))) {
      e.preventDefault();
      applyFilter(document.querySelector('[data-fo2-section="entry-list"]'), el.getAttribute('data-fo2-filter-go'));
      scrollToTarget('#fo2-entry-list');
      return;
    }
    if ((el = t.closest('a[data-fo2-scroll]'))) {
      var href = el.getAttribute('href') || '';
      if (href.charAt(0) === '#' && scrollToTarget(href)) e.preventDefault();
      return;
    }
    if ((el = t.closest('[data-fo2-flip]'))) {
      el.setAttribute('aria-pressed', el.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      return;
    }
    // linked tile: the drawing is a product link, the corner button flips front/back
    if ((el = t.closest('[data-fo2-flip-toggle]'))) {
      var front = el.getAttribute('aria-pressed') !== 'true';
      el.setAttribute('aria-pressed', front ? 'true' : 'false');
      var media = el.closest('.fo2-item__media');
      var flip = media && media.querySelector('.fo2-flip');
      if (flip) flip.classList.toggle('is-front', front);
      return;
    }
    if ((el = t.closest('[data-fo2-quick]'))) { togglePanel(el); return; }
    if ((el = t.closest('[data-fo2-panel-close]'))) {
      var item = el.closest('[data-fo2-item]');
      closePanel(item);
      var q = item && item.querySelector('[data-fo2-quick]');
      if (q) q.focus({ preventScroll: true });
      return;
    }
    if ((el = t.closest('[data-fo2-add]'))) {
      var scope = el.closest('[data-fo2-item]') || el.closest('[data-fo2-rev]');
      addToCart([{ id: Number(el.getAttribute('data-fo2-add')), quantity: 1 }], el, scope).then(function (ok) {
        if (ok && scope && scope.hasAttribute('data-fo2-item')) closePanel(scope);
      });
      return;
    }
    if ((el = t.closest('[data-fo2-side]'))) { showSide(el); return; }
    if ((el = t.closest('[data-fo2-set-size]'))) { pickSetSize(el); return; }
    if ((el = t.closest('[data-fo2-set-add]'))) { addSet(el); return; }
    if ((el = t.closest('[data-fo2-egg-open]'))) { openEgg(); return; }
    if ((el = t.closest('[data-fo2-egg-close]'))) { closeEgg(); return; }
    if ((el = t.closest('[data-fo2-egg-copy]'))) { copyCode(el); return; }
    if ((el = t.closest('[data-fo2-egg-apply]'))) { applyCode(); return; }
    if ((el = t.closest('#fo2-egg')) && el === t) { closeEgg(); }  // click on the backdrop
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $all('[data-fo2-panel]:not([hidden])').forEach(function (p) { closePanel(p.closest('[data-fo2-item]')); });
  });

  function init() {
    fillLiveryCounts();
    initEgg();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
